module.exports = __webpack_public_path__ + "static/media/badminton.ab54d307.svg";